<template>
    <li class="blog-paginator__item"><a v-on:click="SendFilter($event.target, pag)" v-bind:class="active">{{pag}}</a></li>
</template>
<script >
    export default{
        props: ['pag'],
          methods:{
            SendFilter(element, page){
                this.$parent.PageFilter = '?page='+ page
            }
          },
          computed:{
            active(){
              var clase = 'blog-paginator__link'
              if(this.pag === this.$parent.page_obj){
                clase = clase + ' blog-paginator__link--active'
              }
              return clase
            }
          }
    }
</script>


// WEBPACK FOOTER //
// src/modules/blog/andromeda/components/paginatorItem.vue